import { Item, CreateItemRequest, CreateItemResponse } from "@functions-types";
import { makeCloudFunction } from "../makeCloudFunction";

export type { Item };
export const createItem = makeCloudFunction<
  CreateItemRequest,
  CreateItemResponse
>("item", "createItem");
